import React from "react";
import { defaultFont } from "../../../assets/fonts/defaultFont";
import LiroyText from "./LiroyText";

export function Text20({ children, ...props }) {
    return (
        <LiroyText {...props} fontWeight={defaultFont.regular} size={20}>
            {children}
        </LiroyText>
    );
}
